import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobeComponent } from './simple-icons-adobe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobeComponent ],
    exports:      [ SimpleIconsAdobeComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobeModule {}
